export default "<h1 class=\"page-title\">Scotch</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";